// removed by extract-text-webpack-plugin
module.exports = {"Avatar":"Avatar__Avatar___1MwWs","Image":"Avatar__Image___3lxFH"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/Avatar/Avatar.scss
// module id = 1472
// module chunks = 0